// https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html
$('document').ready(function () {

	var owlCarousel = $('.owl-carousel');

	$('.logo-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 2,
		nav: true,
		dots: true,
		responsive: {
			0: {
				items: 3,
			},
			576: {
				items: 5,

			},
			992: {
				items: 6,
			},
			1200: {
				items: 6,
			}
		}
	});
	$('.image-slider').owlCarousel({
		loop: true,
		autoplay: false,
		margin: 2,
		nav: true,
		dots: true,
		items: 1,
		responsive: {
			0: {
				stagePadding: 50,
			},
			576: {
				stagePadding: 80,
			},
			992: {
				stagePadding: 300,
			},
			1200: {
				stagePadding: 300,
			}
		}
	});
	$('.testimonial-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 2,
		nav: true,
		dots: true,
		items: 1,
	});
	$('.block-slider').owlCarousel({
		loop: false,
		nav: true,
		dots: true,
		items: 2,
		autoHeight: true,
		responsive: {
			0: {
				stagePadding: 0,
				items: 1,
				margin: 10,
			},
			576: {
				stagePadding: 60,
				margin: 10,
				items: 1,
			},
			992: {
				stagePadding: 50,
				margin: -30,
			},
			1200: {
				stagePadding: 100,
				margin: -30,
			}
		}
	});
	$('.stories-slider').owlCarousel({
		loop: false,
		autoplay: false,
		nav: true,
		dots: true,
		items: 2,
		autoHeight: true,
		responsive: {
			0: {
				stagePadding: 0,
				items: 1,
				margin: 20,
			},
			576: {
				stagePadding: 60,
				margin: 10,
				items: 1,
			},
			992: {
				stagePadding: 50,
				margin: 20,
			},
			1200: {
				stagePadding: 80,
				margin: 20,
			}
		}
	});
	$('.numbered-slider').owlCarousel({
		autoplay: false,
		nav: true,
		dots: true,
		items: 2,
		center: true,
		loop: true,
		margin: -150,
		responsive: {
			0: {
				margin: -10,
				items: 1,
			},
			576: {
				margin: -50,
				items: 1,
			},
			992: {
				margin: -100,
			},
			1200: {
				margin: -150,
			}
		}
	});
	$('.beyond-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 2,
		dots: true,
		nav: true,
		center: false,
		responsive: {
			0: {
				items: 1,
			},
			576: {
				items: 2,
			},
			992: {
				items: 3,
			},
			1200: {
				items: 3,
			}
		}
	});

	// Wrap around nav & dots
	owlCarousel.each(function (index) {
		$(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
	});

});
